import type { SVGProps } from 'react'

// A cohesive set of modern line icons drawn specifically for the primary navigation. Kept separate
// from the shared icon set so the nav can have its own refined weight and rounding without
// disturbing icons used elsewhere. All share a 24x24 box, 1.75 stroke, round caps and joins.
type NavIconProps = SVGProps<SVGSVGElement>

function base(props: NavIconProps) {
  return {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    ...props,
  }
}

export function NavHomeIcon(props: NavIconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 10.5 12 4l8 6.5" />
      <path d="M5.5 9.5V19a1 1 0 0 0 1 1H10v-4.5a2 2 0 0 1 4 0V20h3.5a1 1 0 0 0 1-1V9.5" />
    </svg>
  )
}

export function NavEnquiriesIcon(props: NavIconProps) {
  return (
    <svg {...base(props)}>
      <path d="M21 11.5a8.5 8.5 0 0 1-12.2 7.66L4 20.5l1.34-4.8A8.5 8.5 0 1 1 21 11.5Z" />
      <path d="M8.5 10.5h7M8.5 13.5h4.5" />
    </svg>
  )
}

export function NavCasesIcon(props: NavIconProps) {
  return (
    <svg {...base(props)}>
      <rect x="3" y="7.5" width="18" height="12.5" rx="2.5" />
      <path d="M8.5 7.5V6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.5" />
      <path d="M3 12.5h18" />
    </svg>
  )
}

export function NavInvoicesIcon(props: NavIconProps) {
  return (
    <svg {...base(props)}>
      <path d="M6 3.5h8.5L19 8v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19V5a1.5 1.5 0 0 1 1-1.5Z" />
      <path d="M14 3.5V8h4.5" />
      <path d="M8.5 12.5h7M8.5 16h4.5" />
    </svg>
  )
}

export function NavDsaIcon(props: NavIconProps) {
  return (
    <svg {...base(props)}>
      <path d="M9.5 4 7 20M17 4l-2.5 16" />
      <path d="M4.5 8.75h15M4 15.25h15" />
    </svg>
  )
}
